const _version = "3.6.0"
function version() {
    return _version
}
export default version
